import { PaymentMethod } from "../autopay";

export class UpdateAutopayRequest {
	postedInfo = null;
    constructor(
        public paymentMethod: PaymentMethod,
        public maxPaymentAmount?: number,
        public payInFull?: boolean,
    ){ }
}

